namespace Matrix.Data {
    export namespace TestResultService {
        export const baseUrl = 'Data/TestResult';

        export declare function Create(request: Serenity.SaveRequest<TestResultRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TestResultRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TestResultRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TestResultRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Mute(request: TestResultMutingRequest, onSuccess?: (response: TestResultMutingResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Data/TestResult/Create",
            Update = "Data/TestResult/Update",
            Delete = "Data/TestResult/Delete",
            Retrieve = "Data/TestResult/Retrieve",
            List = "Data/TestResult/List",
            Mute = "Data/TestResult/Mute"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Mute'
        ].forEach(x => {
            (<any>TestResultService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
